import {
  compose, hoistStatics,
} from 'recompose';

import TextArea from './textArea';

const enhance = compose(
);
export default hoistStatics(enhance)(TextArea);
